import { render } from "./ParksView.vue?vue&type=template&id=68ef0d12&scoped=true&ts=true"
import script from "./ParksView.vue?vue&type=script&lang=ts"
export * from "./ParksView.vue?vue&type=script&lang=ts"

import "./ParksView.vue?vue&type=style&index=0&id=68ef0d12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ef0d12"]])

export default __exports__